const titleMap = {
    'home': { he: 'ראשי', ar: 'الصفحة الرئيسيّة' },
    'my-lerning': { he: 'הלימודים שלי', ar: 'הלימודים שלי' },
    'calendar': { he: 'יומן', ar: 'يوميات' },
    'discovery': { he: 'חיפוש', ar: 'بحث' },
    'matriculation': { he: 'בגרויות', ar: 'بجروت' },
    'admin': { he: 'ניהול', ar: 'إدارة ' },
    'new': { he: 'חדש', ar: 'جديد ' },
    'delay-navigate': { he: 'הנך מועבר לעמוד המבוקש', ar: 'سيتم نقلكم إلى الصفحة المطلوبة' },
    'reports': { he: 'דוחות', ar: 'تقارير' },
    'finalProjects': { he: 'עבודת גמר', ar: 'عمل نهائي' },
    'bot': { he: 'בוט עוזר אישי', ar: 'בוט עוזר אישי' },
};

export default titleMap;